import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

import { debounceTime, Subject } from 'rxjs';
import { NotifierService } from 'angular-notifier';
import { EmailconfigService } from './service/emailconfigservice.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';

import * as CryptoJS from 'crypto-js';
import { LoginService } from '../../../../components/login/service/login.service';
import validationform from '../../../../validation/validationform';
@Component({
  selector: 'app-email-configuration',
  templateUrl: './email-configuration.component.html',
  styleUrl: './email-configuration.component.scss'
})
export class EmailConfigurationComponent {

  editTopic: any;
  topicForm!: FormGroup;
  showCard = false;
  showButton = false;
  getIndex!: number;
  tabTriangle = 'configtopic';
  countCall!: number;
  countMetric!: number;
  stopWordTab = 'a';
  stopWordTblData: any = [];
  topicConfigData: any = [];
  one = 1;
  weight = 'false';
  getId!: any;
  updateBoolean = false;
  splitPattern = new RegExp('[,;]');
  deleteIndex?: any;
  closeModal = false;
  myOptions!: object;
  survyData: any = [];
  survyTableData: any = [];
  isExpanded1 = false;
  isExpanded2 = false;
  isExpanded3 = false;
  isExpanded4 = false;
  NotificationData: any = [];
  notificationForm!: FormGroup;
  stopWords = '';
  stopWords2: any = [];
  getStopWordIndex!: number;
  searchText = '';
  stopWordBtnShow: boolean = true;
  stopWordShowInput = 'edit';
  spinner = false;
  surveyForm!: FormGroup;
  surveyForm2!: FormGroup;
  tableTrVar!: number;
  expandTopicsAllTabsValue!: string;

  mailAutoReplyData:any=[];
 eyeIcon = 'fa-eye-slash';

  editorConfig: AngularEditorConfig = {
      editable: true,
      spellcheck: true,
      height: 'auto',
      minHeight: '150',
      maxHeight: 'auto',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter text here...',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
      
      
      uploadWithCredentials: false,
      fonts: [
        { class: 'arial', name: 'Arial' },
        { class: 'times-new-roman', name: 'Times New Roman' },
        { class: 'calibri', name: 'Calibri' },
        { class: 'comic-sans-ms', name: 'Comic Sans MS' },
      ],
      customClasses: [
        {
          name: 'quote',
          class: 'quote',
        },
        {
          name: 'redText',
          class: 'redText',
        },
        {
          name: 'titleText',
          class: 'titleText',
          tag: 'h1',
        },
      ],
      sanitize: true,
      toolbarPosition: 'top',
      toolbarHiddenButtons: [['bold', 'italic'], ['fontSize']],
    };

  categoriesList:any=[];
  qaParameterList:any=[];
  errorTypeList:any=[];
  clientList:any=[];
  callTypeList:any=[];

  topicConfigForm:FormGroup = new FormGroup({});
  categoryConfigForm:FormGroup = new FormGroup({});
  qaParamConfigForm:FormGroup = new FormGroup({});
  mailAutoReplyConfigForm:FormGroup = new FormGroup({});
  mailConfigForm:FormGroup=new FormGroup({});
  submitted:boolean=false;

  topicConfig_id:any=null;
  categoryConfig_id:any=null;
  qaParam_id:any=null;
  mailAutoReplyConfig_id:any=null;
  @ViewChild('closebutton') closebutton: any;
  private readonly notifier: NotifierService;
  @ViewChild('topicModal') topicModal: any;
  @ViewChild('accordionBtn1') accordionBtn1: any;
  @ViewChild('accordionBtn2') accordionBtn2: any;
  @ViewChild('accordionBtn3') accordionBtn3: any;
  @ViewChild('accordionBtn4') accordionBtn4: any;
  @ViewChild('addSurveySecondSectionId') addSurveySecondSectionId!: ElementRef;
  @ViewChild('timingElem') timingElem!:ElementRef;
  @ViewChild('keywordElem') keywordElem!:ElementRef;
  @ViewChild('keywordTypeElem') keywordTypeElem!:ElementRef;
  public stopWordSearch!: string;
  stopWordSearchUpdate = new Subject<string>();
  expandButtonShow: boolean = false;
  userDetails: any;
  metricFullscreen:boolean=false;
  checkboxvalue:number=0;
  client_id:any=null;
  //client_id:any="6895936f0187d436721e86f6";
  selectedApps:any;
  call_type_id:any;
  constructor(
    private fb: FormBuilder,
    private configService: EmailconfigService,
   // private appComponent: AppComponent,
    private notifierService: NotifierService,
    private elem:ElementRef,
    private renderer:Renderer2,
    private service:LoginService
  ) {
    this.notifier = notifierService;
    this.stopWordSearchUpdate.pipe(debounceTime(400)).subscribe((value:any) => {
      if (this.stopWordSearch) {
        this.getStopWordData(value, 'input');
      } else {
        this.getStopWordData('a', 'input');
      }
    });
  }

  ngOnInit(): void {
     let user:any = localStorage.getItem("user");
      
          var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
             this.userDetails = JSON.parse(data);
   // this.userDetails = this.appComponent.userDetailsAppComp;
  
  this.callTypeList=[{
      'id':1,
      'name':'Email',
      'is_active':true
    },
     {
      'id':2,
      'name':'Text',
      'is_active':true
    },
    {
      'id':3,
      'name':'Document',
      'is_active':true
    }];
    if(localStorage.getItem('selectedApps')){
      this.selectedApps=localStorage.getItem('selectedApps')?.toString() || "";
    }
    this.myOptions = {
      placement: 'top',
      hideDelay: 0,
      showDelay: 200,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
      zIndex: 10000
    };
    this.topicForm = this.fb.group({
      call_type: [null, Validators.required],
      config_name: [null, Validators.required],
      keywords: [''],
      alert_words: [''],
      sensitive_words: [''],
      hide_words: [''],
      delete_words: [''],
      pause_fillers: [''],
      positive_fillers: [''],
      to_email: [''],
      client_id: [''],
      pause_fillers_score: [null],
      qa_params: this.fb.array([]),
      qa_category: this.fb.array([]),
    });
   // this.topicForm.controls['client_id'].setValue(this.client_id);
    //this.topicForm.controls['call_type'].setValue('inbound');
    

    this.notificationForm = this.fb.group({
      alert: [false],
      complete: [false],
      failure: [false],
    });

    this.surveyForm = this.fb.group({
      survey_name: [''],
      question_answers: this.fb.array([]),
    });


    this.topicConfigForm = this.fb.group({
        call_type_id:['',[Validators.required]],
        config_name:['',[Validators.required,Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
        to_email:['',[Validators.required, Validators.email]],
        client_id:['',[Validators.required]],
    });

    if(this.selectedApps=="email"){
      this.call_type_id = 1;
       this.topicConfigForm.controls['call_type_id'].setValue(1);
    }
    if(this.selectedApps=="text"){
      this.call_type_id = 2;
       this.topicConfigForm.controls['call_type_id'].setValue(2);
    }
    if(this.selectedApps=="document"){
      this.call_type_id = 3;
       this.topicConfigForm.controls['call_type_id'].setValue(3);
    }
    
    this.checkboxvalue=1;
    this.categoryConfigForm = this.fb.group({
      config_id:['',Validators.required],
      category_name:['',[Validators.required,Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
      category_type:[''],
      content_type:['',Validators.required],
      color:['',Validators.required],
      keywords:['',Validators.required]
    });

    this.qaParamConfigForm = this.fb.group({
      config_id:['',Validators.required],
      qa_param:['',Validators.required],
      qa_param_type:['',Validators.required],
      content_type:['',Validators.required],
      color:['',Validators.required],
      score:['',Validators.required],
      error_type_id:[null,Validators.required],
      non_score:[false],
      weightage:[false],
      negative:[false],
      auto_score:[false],
      keywords:['',Validators.required]
    });

    this.mailAutoReplyConfigForm = this.fb.group({
      template_name:['',[Validators.required,this.noWhitespaceValidator(),Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
      trigger_type:['',Validators.required],
      trigger_time:['',Validators.required],
      trigger_condition:['',Validators.required],
      keyword_type:['',Validators.required],
      keyword:['',Validators.required],
      subject:['',[Validators.required,this.noWhitespaceValidator()]],
      message_body:['',[Validators.required,this.noWhitespaceValidator()]],
      reply_to:['',Validators.required]
    });

     this.mailConfigForm = this.fb.group({
      'email_id':['',[Validators.required]],
      'from_id':['',[Validators.required]],
      'exclude_from_id':[''],
      'app_client_id':['',Validators.required],
      'app_client_secret':['',Validators.required],
      'azure_ad_tenant_id':['',Validators.required]
    });
    

    this.configService.getErrortypes().subscribe((res:any)=>{
             this.errorTypeList = res;
    });

    // this.configService.getCallType().subscribe((res:any)=>{
    //         this.callTypeList = res;
    // });

    this.configService.getClient().subscribe((res:any)=>{
          this.clientList = res;
          if(this.clientList.length > 0){
            this.client_id = this.clientList[0]['id'];
            this.getAutoMailData();
          }
    });
 this.getTopicData();
   
   this.getmailConfig();

  }

  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isWhitespace = (control.value || '').trim().length === 0;
      return isWhitespace ? { whitespace: true } : null;
    };
  }

  trimValidator(): ValidatorFn   {
    return (control: AbstractControl): ValidationErrors | null => {
      const isWhitespace = control.value.startsWith(' ');
      return isWhitespace ? { trimError: true } : null;
    };
  }

  onChangeEditor(event:any){
    var regExp = /^[a-z]/;
     if (!regExp.test(event)) {
        this.mailAutoReplyConfigForm.get("message_body")?.setErrors({whitespace: true});
      }
   } 

  get question_answers() {
    return this.surveyForm.controls['question_answers'] as FormArray;
  }

   get fmailin(){
    return this.mailConfigForm.controls;
  }

  surveyFirstSection(): FormArray {
    return this.surveyForm.get('question_answers') as FormArray;
  }

  addQuestion(): FormGroup {
    return this.fb.group({
      question: [null],
      answers: this.fb.array([]),
    });
  }

  addSurveyFirstSection(value?: string) {
    this.surveyFirstSection().push(this.addQuestion());
    if (value !== 'edit') {
      this.addSurveySecondSection(this.surveyFirstSection().length - 1);
    }
  }

  surveySecondSection(index: number): FormArray {
    return this.surveyFirstSection()?.at(index)?.get('answers') as FormArray;
  }

  addMoreData(): FormGroup {
    return this.fb.group({
      answer: [null],
      score: [null],
    });
  }

  addSurveySecondSection(index: number) {
    this.surveySecondSection(index)?.push(this.addMoreData());
  }

  exitSurveyModal() {
    this.surveyForm.reset();
    this.question_answers.clear();
    this.showButton = false;
  }

  getTopicData() {
    //this.spinner = true;
     //this.metricFullscreen=true;

    this.configService.getTopicKeyword().subscribe(
      (response:any) => {
        this.topicConfigData = response;
        this.topicConfigData.reverse();
        this.spinner = false;
        if(this.topicConfigData.length > 0){
          // this.getCategoryData(this.topicConfigData[0]['config_id']);
           //this.getQaParameterData(this.topicConfigData[0]['config_id']);
        }
      },
      (error:HttpErrorResponse) => {
        console.log('getTopicKeyword error', error);
        this.spinner = false;
      }
    );
  }

  tableBack(index: number) {
    this.tableTrVar = index;
  }

  onSubmit() {
    if (this.topicForm.valid) {
      const formValue = this.topicForm.value;
      const metricValue = formValue.qa_params;
      let metricArray = [];
      for (let i = 0; i < metricValue.length; i++) {
        if (metricValue[i].weitage) {
          metricValue[i].weitage = 'true';
        } else if (!metricValue[i].weitage) {
          metricValue[i].weitage = 'false';
        }
        if (metricValue[i].active) {
          metricValue[i].active = 'true';
        } else if (!metricValue[i].active) {
          metricValue[i].active = 'false';
        }
        if (metricValue[i].free_score) {
          metricValue[i].free_score = 'true';
        } else if (!metricValue[i].free_score) {
          metricValue[i].free_score = 'false';
        }
        if (metricValue[i].negative_question) {
          metricValue[i].negative_question = 'true';
        } else if (!metricValue[i].negative_question) {
          metricValue[i].negative_question = 'false';
        }
        metricArray.push(metricValue[i]);
      }

      const callCategoryValue = formValue.qa_category;
      let callCategoryArray = [];
      for (let i = 0; i < callCategoryValue.length; i++) {
        if (callCategoryValue[i].active) {
          callCategoryValue[i].active = 'true';
        } else if (!callCategoryValue[i].active) {
          callCategoryValue[i].active = 'false';
        }
        callCategoryArray.push(callCategoryValue[i]);
      }
      const keyword = formValue.keywords?.toString()
        ? formValue.keywords?.toString()
        : '';
      const alertKeyword = formValue.alert_words?.toString()
        ? formValue.alert_words?.toString()
        : '';
      const sensitiveKeyword = formValue.sensitive_words?.toString()
        ? formValue.sensitive_words?.toString()
        : '';
      const hideKeyword = formValue.hide_words?.toString()
        ? formValue.hide_words?.toString()
        : '';
      const deleteKeyword = formValue.delete_words?.toString()
        ? formValue.delete_words?.toString()
        : '';
      const negativeKeyword = formValue.pause_fillers
        ? formValue.pause_fillers
        : [];
      const positiveKeyword = formValue.positive_fillers
        ? formValue.positive_fillers
        : [];
      formValue.keywords = keyword;
      formValue.alert_words = alertKeyword;
      formValue.sensitive_words = sensitiveKeyword;
      formValue.hide_words = hideKeyword;
      formValue.delete_words = deleteKeyword;
      formValue.pause_fillers = negativeKeyword;
      formValue.positive_fillers = positiveKeyword;
      formValue.qa_params = metricArray;
      formValue.qa_category = callCategoryArray;
    //  this.topicKeywordData.unshift(formValue);
      this.configService.saveTopics(formValue).subscribe(
        (sub:any) => {
          this.notifier.notify('default', 'Saved Successfully');
          this.exitIconReset();
          this.getTopicData();
        },
        (error:HttpErrorResponse) => {
          console.log('submitted error', error);
        }
      );
      this.closebutton.nativeElement.click();
    } else {
      validationform.ValidateAllFormFields(this.topicForm);
    }
  }

  get qa_category() {
    return this.topicForm.controls['qa_category'] as FormArray;
  }

  get qa_params() {
    return this.topicForm.controls['qa_params'] as FormArray;
  }

  addcall_category() {
    const lessonForm = this.fb.group({
      active: [true],
      category: [null, Validators.required],
      keywords: [null, Validators.required],
      color: [null, Validators.required],
    });
    this.qa_category.push(lessonForm);
    this.showCard = true;
  }

  deletecall_category(index: number) {
    this.qa_category.removeAt(index);
  }

  addmetrics() {
  
      const lessonForm = this.fb.group({
        active: [true],
        category: [null, Validators.required],
        keywords: [null, Validators.required],
        score: [null, [Validators.required]],
        weitage: [false],
        free_score: [false],
        negative_question: [false],
        type_error:[null]
      });
      this.qa_params.push(lessonForm);
     
    
    
   
    this.showCard = true;
  }

  deletemetrics(index: number) {
    this.qa_params.removeAt(index);
  }

  getTopicsData(index: number) {
    this.updateBoolean = true;
    this.showButton = true;
    this.getIndex = index;
   // this.editTopic = this.topicKeywordData[index];
    //this.getId = this.topicKeywordData[index].id?.$oid;
    const metricValue = this.editTopic.qa_params;
    let metricArray = [];
    for (let i = 0; i < metricValue.length; i++) {
      if (metricValue[i].weitage === 'true') {
        metricValue[i].weitage = true;
      } else if (metricValue[i].weitage === 'false') {
        metricValue[i].weitage = false;
      }
      if (metricValue[i].active === 'true') {
        metricValue[i].active = true;
      } else if (metricValue[i].active === 'false') {
        metricValue[i].active = false;
      }
      if (metricValue[i].free_score === 'true') {
        metricValue[i].free_score = true;
      } else if (metricValue[i].free_score === 'false') {
        metricValue[i].free_score = false;
      }
      if (metricValue[i].negative_question === 'true') {
        metricValue[i].negative_question = true;
      } else if (metricValue[i].negative_question === 'false') {
        metricValue[i].negative_question = false;
      }
      metricArray.push(metricValue[i]);
    }

    const callCategoryValue = this.editTopic.qa_category;
    let callCategoryArray = [];
    for (let i = 0; i < callCategoryValue.length; i++) {
      if (callCategoryValue[i].active === 'true') {
        callCategoryValue[i].active = true;
      } else if (callCategoryValue[i].active === 'false') {
        callCategoryValue[i].active = false;
      }
      callCategoryArray.push(callCategoryValue[i]);
    }
    const formObject = {
      call_type: this.editTopic.call_type,
      topic: this.editTopic.topic,
      keywords: this.editTopic.keywords
        ? this.editTopic.keywords?.split(',')
        : null,
      alert_words: this.editTopic.alert_words
        ? this.editTopic.alert_words?.split(',')
        : null,
      sensitive_words: this.editTopic.sensitive_words
        ? this.editTopic.sensitive_words?.split(',')
        : null,
      hide_words: this.editTopic.hide_words
        ? this.editTopic.hide_words?.split(',')
        : null,
      delete_words: this.editTopic.delete_words
        ? this.editTopic.delete_words?.split(',')
        : null,
      pause_fillers: this.editTopic.pause_fillers,
      positive_fillers: this.editTopic.positive_fillers,
      mail_copies: this.editTopic.mail_copies,
      qa_params: metricArray,
      qa_category: callCategoryArray,
    };
    this.topicForm.patchValue(formObject);
   // this.countCall = this.topicKeywordData[this.getIndex].qa_category.length;
   // this.countMetric = this.topicKeywordData[this.getIndex].qa_params.length;
    for (let i = 0; i < this.countCall; i++) {
      this.addcall_category();
      // this.qa_category.patchValue(
      // this.topicKeywordData[this.getIndex].qa_category
      // );
    }
    for (let i = 0; i < this.countMetric; i++) {
      this.addmetrics();
     // this.qa_params.patchValue(this.topicKeywordData[this.getIndex].qa_params);
    }
  }

  updateForm() {
    if (this.topicForm.valid) {
      const formValue2 = this.topicForm.value;
      const metricValue = formValue2.qa_params;
      let metricArray = [];
      for (let i = 0; i < metricValue.length; i++) {
        if (metricValue[i].weitage) {
          metricValue[i].weitage = 'true';
        } else if (!metricValue[i].weitage) {
          metricValue[i].weitage = 'false';
        }
        if (metricValue[i].active) {
          metricValue[i].active = 'true';
        } else if (!metricValue[i].active) {
          metricValue[i].active = 'false';
        }
        if (metricValue[i].free_score) {
          metricValue[i].free_score = 'true';
        } else if (!metricValue[i].free_score) {
          metricValue[i].free_score = 'false';
        }
        if (metricValue[i].negative_question) {
          metricValue[i].negative_question = 'true';
        } else if (!metricValue[i].negative_question) {
          metricValue[i].negative_question = 'false';
        }

        metricArray.push(metricValue[i]);
      }

      const callCategoryValue = formValue2.qa_category;
      let callCategoryArray = [];
      for (let i = 0; i < callCategoryValue.length; i++) {
        if (callCategoryValue[i].active) {
          callCategoryValue[i].active = 'true';
        } else if (!callCategoryValue[i].active) {
          callCategoryValue[i].active = 'false';
        }
        callCategoryArray.push(callCategoryValue[i]);
      }
      const formValue = this.topicForm.value;
      const keyword = formValue.keywords ? formValue.keywords?.toString() : '';
      const alertKeyword = formValue.alert_words
        ? formValue.alert_words?.toString()
        : '';
      const sensitiveKeyword = formValue.sensitive_words
        ? formValue.sensitive_words?.toString()
        : '';
      const hideKeyword = formValue.hide_words
        ? formValue.hide_words?.toString()
        : '';
      const deleteKeyword = formValue.delete_words
        ? formValue.delete_words?.toString()
        : '';
      const negativeKeyword = formValue.pause_fillers
        ? formValue.pause_fillers
        : [];
      const positiveKeyword = formValue.positive_fillers
        ? formValue.positive_fillers
        : [];
      const mail_copies = formValue.mail_copies ? formValue.mail_copies : '';
     // const id = this.topicKeywordData[0].id;
      const client_id = 1;
      const topic_ref_count = 0;

      formValue.client_id = client_id;
      formValue.keywords = keyword;
      formValue.alert_words = alertKeyword;
      formValue.sensitive_words = sensitiveKeyword;
      formValue.hide_words = hideKeyword;
      formValue.delete_words = deleteKeyword;
      formValue.pause_fillers = negativeKeyword;
      formValue.positive_fillers = positiveKeyword;
      formValue.mail_copies = mail_copies;
      formValue.topic_ref_count = topic_ref_count;
     // formValue.id = id;
      formValue.qa_params = metricArray;
      formValue.qa_category = callCategoryArray;
      // this.configService.updateTopic(this.getId, formValue).subscribe(
      //   (sub) => {
      //     this.getTopicData();
      //     this.notifier.notify('default', 'Updated Successfully');
      //     this.closebutton.nativeElement.click();
      //     this.exitIconReset();
      //   },
      //   (error) => {
      //     console.log('updated topic error', error);
      //   }
      // );
    } else {
      validationform.ValidateAllFormFields(this.topicForm);
    }
  }

  exitIconReset() {
    setTimeout(() => {
      this.topicConfigForm.reset();
      this.categoryConfigForm.reset();
      this.qaParamConfigForm.reset();
      this.mailAutoReplyConfigForm.reset();
      this.qa_category.clear();
      this.qa_params.clear();
      this.topicConfigForm.controls['call_type_id'].setValue(this.call_type_id);
      this.topicConfigForm.controls['client_id'].setValue('');
      if (this.isExpanded1) {
        this.accordionBtn1.nativeElement.click();
      }
      if (this.isExpanded2) {
        this.accordionBtn2.nativeElement.click();
      }
      if (this.isExpanded3) {
        this.accordionBtn3.nativeElement.click();
      }
      if (this.isExpanded4) {
        this.accordionBtn4.nativeElement.click();
      }
      this.expandButtonShow = false;
    }, 400);
  }

  expandTopicsAllTabs(value: string) {
    this.expandButtonShow = !this.expandButtonShow;
    this.expandTopicsAllTabsValue = value;
    if (value === 'collapse') {
      if (this.isExpanded1) {
        this.accordionBtn1.nativeElement.click();
      }
      if (this.isExpanded2) {
        this.accordionBtn2.nativeElement.click();
      }
      if (this.isExpanded3) {
        this.accordionBtn3.nativeElement.click();
      }
      if (this.isExpanded4) {
        this.accordionBtn4.nativeElement.click();
      }
    }

    if (value === 'expand') {
      if (!this.isExpanded1) {
        this.accordionBtn1.nativeElement.click();
      }
      if (!this.isExpanded2) {
        this.accordionBtn2.nativeElement.click();
      }
      if (!this.isExpanded3) {
        this.accordionBtn3.nativeElement.click();
      }
      if (!this.isExpanded4) {
        this.accordionBtn4.nativeElement.click();
      }
    }
  }

  toggleCollapsed(value: string) {
    let buttonShow = false;
    if (value === '1') {
      this.isExpanded1 = !this.isExpanded1;
      if (this.isExpanded1) {
        this.expandButtonShow = true;
      } else if (this.expandTopicsAllTabsValue === 'collapse') {
        this.expandButtonShow = false;
      }
    }
    if (value === '2') {
      this.isExpanded2 = !this.isExpanded2;
      if (this.isExpanded2) {
        this.expandButtonShow = true;
      } else if (this.expandTopicsAllTabsValue === 'collapse') {
        this.expandButtonShow = false;
      }
    }
    if (value === '3') {
      this.isExpanded3 = !this.isExpanded3;
      if (this.isExpanded3) {
        this.expandButtonShow = true;
      } else if (this.expandTopicsAllTabsValue === 'collapse') {
        this.expandButtonShow = false;
      }
    }
    if (value === '4') {
      this.isExpanded4 = !this.isExpanded4;
      if (this.isExpanded4) {
        this.expandButtonShow = true;
      } else if (this.expandTopicsAllTabsValue === 'collapse') {
        this.expandButtonShow = false;
      }
    }
    if (
      !this.isExpanded1 &&
      !this.isExpanded2 &&
      !this.isExpanded3 &&
      !this.isExpanded4
    ) {
      buttonShow = true;
      this.expandButtonShow = false;
    } else {
      this.expandButtonShow = true;
    }
  }

  showButtonFun() {
    this.showButton = false;
    this.updateBoolean = false;
    this.checkboxvalue = this.topicConfigForm.value['call_type_id'];
  }

  deleteTopic(index: number) {
    if(this.tabTriangle=="configtopic"){
    const id= parseInt(this.topicConfigData[index]['config_id']);
    this.configService.deleteTopicData(id).subscribe(
      (sub:any) => {
       this.topicConfigData.splice(index, 1);
        this.notifier.notify('default', 'Deleted Successfully');
      },(error:HttpErrorResponse) => {
        this.notifier.notify('error',error['error']['message']);
      });
   }else if(this.tabTriangle==='category'){
    const id= parseInt(this.categoriesList[index]['id']);
    this.configService.deleteCategory(id).subscribe(
      (sub:any) => {
       this.categoriesList.splice(index, 1);
        this.notifier.notify('default', 'Deleted Successfully');
      },(error:HttpErrorResponse) => {
        this.notifier.notify('error',error['error']['message']);
      } );
   }else if(this.tabTriangle==='parameter'){
    const config_id= parseInt(this.qaParameterList[index]['config_id']);
    const qa_param_id = parseInt(this.qaParameterList[index]['id']);
    this.configService.deleteQaParameter(config_id,qa_param_id).subscribe(
      (sub:any) => {
       this.qaParameterList.splice(index, 1);
        this.notifier.notify('default', 'Deleted Successfully');
      },(error:HttpErrorResponse) => {
         this.notifier.notify('error',error['error']['message']);
      });
   }else if(this.tabTriangle==='mail-auto-reply-config'){
       this.configService.deleteAutoReplyEmailTemplate(this.mailAutoReplyData[index]['id']).subscribe((res:any)=>{
         this.mailAutoReplyData.splice(index,1);
         this.notifier.notify('default','Deleted Successfully');
       },(error:HttpErrorResponse)=>{
          this.notifier.notify('error',error['error']['message']);
       });    
   }
 
  }

  justShowIndex(index: number) {
    this.deleteIndex = index;
  }

  getSurveyData() {
    this.spinner = true;
    this.configService.getSurvey().subscribe({
      next: (response:any) => {
        this.survyData = response;
        this.survyTableData = this.survyData.result;
        this.spinner = false;
      },
      error: (err:HttpErrorResponse) => {
        this.spinner = false;
      },
    });
  }

  sendSurveyIndex(index: number) {
    this.showButton = true;
    for (let i = 0; this.survyTableData[index]?.question_answers.length > i; i++) {
      this.addSurveyFirstSection('edit');
      for (
        let j = 0; this.survyTableData[index]?.question_answers[i].answers.length > j; j++) {
        this.addSurveySecondSection(i);
      }
    }
    this.surveyForm.patchValue(this.survyTableData[index]);
  }

  deleteQuestionAnswerInputs(index: number, index2: number) {
    this.surveySecondSection(index2)?.removeAt(index);
  }

  deleteQuestionInput(index: number) {
    this.surveyFirstSection().removeAt(index);
  }

  stopWordTabFun(tab: string) {
    this.stopWordTab = tab;
  }

  getStopWordData(value: string, id: string) {
    this.stopWordBtnShow = true;
    this.spinner = true;
    if (id === 'tab') {
      this.stopWordSearch = '';
    }
    this.configService.getStopWord(value).subscribe({
      next: (response:any) => {
        const result: any = response;
        this.stopWordTblData = result.result;
        this.spinner = false;
      },
      error: (err:HttpErrorResponse) => {
        console.log(err);
        this.spinner = false;
      },
    });
  }

  showTriangle(value: string) {
    this.tabTriangle = value;
  }

  getNotificationData() {
    this.configService.getEmailConfiguration().subscribe({
      next: (response:any) => {
        this.NotificationData = response;
        this.updateNotification2();
      },
      error: (err:HttpErrorResponse) => {
        console.log(err);
      },
    });
  }

  updateNotification2() {
    if (this.NotificationData.alert_email === 'Y') {
      this.notificationForm.controls['alert'].setValue(true);
    }
    if (this.NotificationData.complete_email === 'Y') {
      this.notificationForm.controls['complete'].setValue(true);
    }
    if (this.NotificationData.failure_email === 'Y') {
      this.notificationForm.controls['failure'].setValue(true);
    }
  }

  updateNotification() {
    const formObject = {
      alert_email:
        this.notificationForm.controls['alert'].value === true ? 'Y' : 'N',
      complete_email:
        this.notificationForm.controls['complete'].value === true ? 'Y' : 'N',
      failure_email:
        this.notificationForm.controls['failure'].value === true ? 'Y' : 'N',
    };
    this.configService.updateEmailConfiguration(formObject).subscribe({
      next: (response:any) => {
        this.NotificationData = response;
        this.updateNotification2();
        this.notificationForm.markAsPristine();
        this.notifier.notify('default', 'Updated Sucessfully!');
      },
      error: (err:HttpErrorResponse) => {
        console.log(err);
        this.notifier.notify(
          'error',
          'server not respond, please try again after sometime!'
        );
      },
    });
  }

  sendStopWordIndex(index: number) {
    this.stopWordBtnShow = true;
    this.getStopWordIndex = index;
    this.stopWords = this.stopWordTblData[index];
  }

  changeInputStopWord() {
    this.stopWordBtnShow = false;
  }

  exitStopWord() {
    this.stopWordBtnShow = true;
    this.stopWords = '';
  }

  updateStopWordFun() {
    const formObject = {
      add_stop_words: [
        this.stopWordShowInput === 'edit'
          ? this.stopWords
          : this.stopWords2.toString(),
      ],
      hide_stop_words: [],
      rem_stop_words:
        this.stopWordShowInput === 'edit'
          ? [this.stopWordTblData[this.getStopWordIndex]]
          : [],
    };
    this.configService.updateStopWord(formObject).subscribe({
      next: (response:any) => {
        this.stopWordTblData[this.getStopWordIndex] =
          formObject.add_stop_words[0];
        this.getStopWordData('a', 'input');
        this.stopWordBtnShow = true;
      },
      error: (err:HttpErrorResponse) => {
        console.log(err);
        this.spinner = false;
      },
    });
  }

  DeleteStopWordFun(index: number) {
    this.getStopWordIndex = index;
    const formObject = {
      add_stop_words: [],
      hide_stop_words: [],
      rem_stop_words: [this.stopWordTblData[this.getStopWordIndex]],
    };
    this.configService.updateStopWord(formObject).subscribe({
      next: (response:any) => {
        this.getStopWordData('a', 'input');
      },
      error: (error:HttpErrorResponse) => {
        console.log(error);
      },
    });
  }

  stopWordModalOpen(value: string) {
    this.stopWordShowInput = value;
  }




  /***************************/

  ValidateChecked_callType(value:any){
 
    if(value==this.topicConfigForm.value['call_type_id']){
      return true;
    }else{
       return false;
    }

   
  }

  selectTopic(event:any){
    if(this.tabTriangle==='parameter'){
      
        this.getQaParameterData(event.target.value);
      
     
    }else{
      this.getCategoryData(event.target.value);
    }
  
  }

  getCategoryData(config_id:any){
    this.spinner = true;
    this.configService.getCategory(config_id).subscribe((res:any)=>{
         this.categoriesList = res['categories'];
         this.spinner = false;
    },(error:any)=>{
      this.spinner = false;
      this.categoriesList = [];
    });
  }

  getQaParameterData(config_id:any){
    this.spinner = true;
     this.configService.getQaParameter(config_id).subscribe((res:any)=>{
             this.qaParameterList = res['qa_params'];
             this.spinner = false;
     },(error:any)=>{
      this.qaParameterList = [];
      this.spinner = false;
     });
  }
  topicConfigFormonSubmit(){
    this.topicConfigForm.markAllAsTouched();
    if(this.topicConfigForm.valid){

      if(this.topicConfig_id==null){
        this.topicConfigForm.value['call_type_id'] = parseInt(this.topicConfigForm.value['call_type_id']);
        this.topicConfigForm.value['client_id'] = parseInt(this.topicConfigForm.value['client_id']);
        this.configService.saveTopics(this.topicConfigForm.value).subscribe((res:any)=>{
          this.notifier.notify('default','Topic saved successfully');
          $('.cancelBtn').trigger('click');
          this.getTopicData();
         },(error:HttpErrorResponse)=>{
          this.notifier.notify('error',error['error']['message']);
         });
      }else{
      
        this.topicConfigForm.value['config_id'] = parseInt(this.topicConfig_id);
        this.topicConfigForm.value['call_type_id'] = parseInt(this.topicConfigForm.value['call_type_id']);
        this.topicConfigForm.value['client_id'] = parseInt(this.topicConfigForm.value['client_id']);
        this.configService.updateTopic(this.topicConfigForm.value).subscribe((res:any)=>{
          this.notifier.notify('default','Topic updated successfully');
          this.getTopicData();
          $('.cancelBtn').trigger('click');
          this.topicConfig_id = null;
          this.topicConfigForm.reset();
         },(error:HttpErrorResponse)=>{
          this.notifier.notify('error',error['error']['message']);
         });
      }
      
    }
  }


  categoryConfigFormonSubmit(){
    this.categoryConfigForm.markAllAsTouched();
   if(this.categoryConfigForm.valid){
    if(this.categoryConfig_id==null){
      this.configService.createCategory(this.categoryConfigForm.value).subscribe((res:any)=>{
        this.notifier.notify('default','Category saved successfully');
        $('.cancelBtn').trigger('click');
        if(this.topicConfigData.length > 0){
          this.getCategoryData(this.topicConfigData[0]['config_id']);
        }
       },(error:HttpErrorResponse)=>{
        this.notifier.notify('error',error['error']['message']);
       });
    }else{
      this.categoryConfigForm.value['config_id'] = parseInt(this.categoryConfigForm.value['config_id']);
      this.categoryConfigForm.value['category_id'] = parseInt(this.categoryConfig_id);
      this.configService.updateCategory(this.categoryConfigForm.value).subscribe((res:any)=>{
        this.notifier.notify('default','Category updated successfully');
        
        $('.cancelBtn').trigger('click');

        if(this.topicConfigData.length > 0){
          this.getCategoryData(this.topicConfigData[0]['config_id']);
        }
       },(error:HttpErrorResponse)=>{
        this.notifier.notify('error',error['error']['message']);
       });
    }
       
    }
  }


  qaParamConfigFormonSubmit(){
    this.qaParamConfigForm.markAllAsTouched();
    if(this.qaParamConfigForm.valid){
      if(this.qaParam_id==null){
        this.qaParamConfigForm.value['config_id'] = parseInt(this.qaParamConfigForm.value['config_id']);
        this.qaParamConfigForm.value['error_type_id'] = parseInt(this.qaParamConfigForm.value['error_type_id']);
        this.qaParamConfigForm.value['score'] = parseInt(this.qaParamConfigForm.value['score']);
        this.configService.createQaParameter(this.qaParamConfigForm.value).subscribe((res:any)=>{
          this.notifier.notify('default','QA parameter saved successfully');
          $('.cancelBtn').trigger('click');
          if(this.topicConfigData.length > 0){
            this.getQaParameterData(this.topicConfigData[0]['config_id']);
          }
         },(error:HttpErrorResponse)=>{
          this.notifier.notify('error',error['error']['message']);
         });
      }else{
        this.qaParamConfigForm.value['param_id'] = parseInt(this.qaParam_id);
        this.qaParamConfigForm.value['error_type_id'] = parseInt(this.qaParamConfigForm.value['error_type_id']);
        this.qaParamConfigForm.value['score'] = parseInt(this.qaParamConfigForm.value['score']);
        this.configService.updateQaParameter(this.qaParamConfigForm.value).subscribe((res:any)=>{
          this.notifier.notify('default','QA parameter updated successfully');
          $('.cancelBtn').trigger('click');
          if(this.topicConfigData.length > 0){
            this.getQaParameterData(this.qaParamConfigForm.value['config_id']);
          }
         },(error:HttpErrorResponse)=>{
          this.notifier.notify('error',error['error']['message']);
         });
      }
     
    }
  }


  getTopicConfigData(index:any){
    this.showButton = true;

    if(this.tabTriangle=='configtopic'){
      this.topicConfig_id = parseInt(this.topicConfigData[index]['config_id']);
      this.checkboxvalue = this.topicConfigData[index]['call_type_id'];
      this.topicConfigForm.patchValue(this.topicConfigData[index]);
    }else if(this.tabTriangle=='category'){
      this.categoryConfig_id = parseInt(this.categoriesList[index]['id']);
      this.categoryConfigForm.patchValue(this.categoriesList[index]);
     if(this.categoryConfigForm.value['category_type']=="Keyword"){
        this.categoryConfigForm.controls["keywords"].setValidators(Validators.required);
        this.categoryConfigForm.controls["keywords"].updateValueAndValidity();
      }else{
        this.categoryConfigForm.controls["keywords"].clearValidators();
        this.categoryConfigForm.controls["keywords"].updateValueAndValidity();
      }
    }
    else if(this.tabTriangle=='parameter'){
  
       this.qaParam_id = parseInt(this.qaParameterList[index]['id']);
       this.qaParamConfigForm.patchValue(this.qaParameterList[index]);
       if(this.qaParamConfigForm.value['category_type']=="Keyword"){
        this.qaParamConfigForm.controls["keywords"].setValidators(Validators.required);
        this.qaParamConfigForm.controls["keywords"].updateValueAndValidity();
       }else{
        this.qaParamConfigForm.controls["keywords"].clearValidators();
        this.qaParamConfigForm.controls["keywords"].updateValueAndValidity();
      }
    }
   
  }

 getCagegoryConfigData(index:any){
    this.showButton = true;
    this.categoryConfig_id = this.categoriesList[index]['config_id'];
    this.topicConfigForm.patchValue(this.topicConfigData[index]);
 }

 getMailAutoReplyConfigData(index:any){
   this.showButton = true;
   this.mailAutoReplyConfig_id=this.mailAutoReplyData[index]['id'];
   this.configService.getAutoReplyEmailTemplateById(this.mailAutoReplyConfig_id).subscribe({
      next:(result:any)=>{
         // this.mailAutoReplyConfigForm.patchValue(this.mailAutoReplyData[index]);
           this.mailAutoReplyConfigForm.patchValue(result);
           if(this.mailAutoReplyConfigForm.value['trigger_type']=="time_based"){
            this.renderer.setStyle(this.timingElem.nativeElement,'display','flex');
            this.mailAutoReplyConfigForm.get("trigger_time")?.setValidators(Validators.required);
            this.mailAutoReplyConfigForm.get("trigger_time")?.updateValueAndValidity();
           }else{
            this.mailAutoReplyConfigForm.get("trigger_time")?.setValue('');
            this.mailAutoReplyConfigForm.get("trigger_time")?.clearValidators();
            this.mailAutoReplyConfigForm.get("trigger_time")?.updateValueAndValidity();
            this.renderer.setStyle(this.timingElem.nativeElement,'display','none');
          }
        
          if(this.mailAutoReplyConfigForm.value['trigger_condition']=="keyword"){
            this.renderer.setStyle(this.keywordElem.nativeElement,'display','flex');
            this.renderer.setStyle(this.keywordTypeElem.nativeElement,'display','flex');
            this.mailAutoReplyConfigForm.get("keyword_type")?.setValidators(Validators.required);
            this.mailAutoReplyConfigForm.get("keyword_type")?.updateValueAndValidity();
            this.mailAutoReplyConfigForm.get("keyword")?.setValidators(Validators.required);
            this.mailAutoReplyConfigForm.get("keyword")?.updateValueAndValidity();
          }else{
            this.mailAutoReplyConfigForm.get("keyword")?.setValue([]);
            this.mailAutoReplyConfigForm.get("keyword")?.clearValidators();
            this.mailAutoReplyConfigForm.get("keyword")?.updateValueAndValidity();
            this.mailAutoReplyConfigForm.get("keyword_type")?.clearValidators();
            this.mailAutoReplyConfigForm.get("keyword_type")?.updateValueAndValidity();
            this.renderer.setStyle(this.keywordElem.nativeElement,'display','none');
            this.renderer.setStyle(this.keywordTypeElem.nativeElement,'display','none');
          }
      },
      error:()=>{

      }
   });
 
  



 }

 ValidateCategoryType(event:any,form:FormGroup){
  if(event.target.value=="AI"){
    form.get("keywords")?.clearValidators();
    form.get("keywords")?.updateValueAndValidity();
  }else{
    form.get("keywords")?.setValidators(Validators.required);
    form.get("keywords")?.updateValueAndValidity();
  }
 
 }

 ValidateMailTriggerType(event:any,form:FormGroup){
   if(event.target.value=="time_based"){
    this.renderer.setStyle(this.timingElem.nativeElement,'display','flex');
    form.get("trigger_time")?.setValidators(Validators.required);
    form.get("trigger_time")?.updateValueAndValidity();
   }else{
    form.get("trigger_time")?.setValue('');
    form.get("trigger_time")?.clearValidators();
    form.get("trigger_time")?.updateValueAndValidity();
     this.renderer.setStyle(this.timingElem.nativeElement,'display','none');
  }
 }

 ValidateMailReplyType(event:any,form:FormGroup){
  if(event.target.value=="keyword"){
    this.renderer.setStyle(this.keywordElem.nativeElement,'display','flex');
    this.renderer.setStyle(this.keywordTypeElem.nativeElement,'display','flex');
    form.get("keyword_type")?.setValidators(Validators.required);
   form.get("keyword_type")?.updateValueAndValidity();
   form.get("keyword")?.setValue('');
   form.get("keyword")?.setValidators(Validators.required);
   form.get("keyword")?.updateValueAndValidity();
  }else{
    form.get("keyword")?.setValue([]);
   form.get("keyword")?.clearValidators();
   form.get("keyword")?.updateValueAndValidity();
   form.get("keyword_type")?.setValue("");
   form.get("keyword_type")?.clearValidators();
   form.get("keyword_type")?.updateValueAndValidity();
   this.renderer.setStyle(this.keywordElem.nativeElement,'display','none');
   this.renderer.setStyle(this.keywordTypeElem.nativeElement,'display','none');
  }

 }

 getAutoMailData(){
  this.configService.getAutoReplyEmailTemplate(this.client_id).subscribe((res:any)=>{
    this.mailAutoReplyData = res;
  });
 }

 mailAutoReplyConfigFormSubmit(){
   this.mailAutoReplyConfigForm.markAllAsTouched();
   if(this.mailAutoReplyConfigForm.valid){
    if(this.mailAutoReplyConfig_id==null){
      if(this.mailAutoReplyConfigForm.value['trigger_time'] !="" && this.mailAutoReplyConfigForm.value['trigger_time'] !=null){
        this.mailAutoReplyConfigForm.value['trigger_time']=this.mailAutoReplyConfigForm.value['trigger_time'].split(":").length==2 ? this.mailAutoReplyConfigForm.value['trigger_time']+':00' :this.mailAutoReplyConfigForm.value['trigger_time'];
      }
      
      this.configService.createAutoReplyEmailTemplate(this.mailAutoReplyConfigForm.value,this.client_id).subscribe((res:any)=>{
        this.notifier.notify('default','Created Successfully');
        this.getAutoMailData();
        $('.cancelBtn').trigger('click');
        this.mailAutoReplyConfigForm.reset();
      },(error:HttpErrorResponse)=>{
        this.notifier.notify('error',error['error']['message']);
      });
    }else{
      if(this.mailAutoReplyConfigForm.value['trigger_time'] !="" && this.mailAutoReplyConfigForm.value['trigger_time'] != null){
        this.mailAutoReplyConfigForm.value['trigger_time']=this.mailAutoReplyConfigForm.value['trigger_time'].split(":").length==2 ? this.mailAutoReplyConfigForm.value['trigger_time']+':00' :this.mailAutoReplyConfigForm.value['trigger_time'];
      }
      this.configService.updateAutoReplyEmailTemplate(this.mailAutoReplyConfigForm.value,this.mailAutoReplyConfig_id).subscribe((res:any)=>{
        this.notifier.notify('default','Updated Successfully');
        this.getAutoMailData();
        $('.cancelBtn').trigger('click');
        this.mailAutoReplyConfigForm.reset();
      },(error:HttpErrorResponse)=>{
        this.notifier.notify('error',error['error']['message']);
      });
    }
      
   }
 }

 getmailConfig(){
   
    this.configService.getMailConfigSettings().subscribe((res:any)=>{
      
       let res_data = res;
       let from_id = res['from_id']!=null ? res['from_id'].split(",") :"";
       let email_id = res['email_id'] !=null ? res['email_id'].split(",") :"";
       let exclude_from_id = res['exclude_from_id'] !=null ? res['exclude_from_id'].split(",") : "";
       res['from_id']=from_id;
       res['email_id']=email_id;
       res['exclude_from_id']=exclude_from_id;
        this.mailConfigForm.patchValue(res);
    })
   
 }

 mailConfig(){
  
    this.submitted=true;
    if(this.mailConfigForm.valid){
      let from_id = this.mailConfigForm.value['from_id'] !=null ? this.mailConfigForm.value['from_id'].join(",") : "";
      let email_id = this.mailConfigForm.value['email_id'] !=null ? this.mailConfigForm.value['email_id'].join(",") : "";
      let exclude_from_id = this.mailConfigForm.value['exclude_from_id'] !=null ? this.mailConfigForm.value['exclude_from_id'].join(",") : "";
      this.mailConfigForm.value['from_id']=from_id;
      this.mailConfigForm.value['email_id']=email_id;
      this.mailConfigForm.value['exclude_from_id']=exclude_from_id;
      this.configService.saveMailConfigSettings(this.mailConfigForm.value).subscribe((res:any)=>{
        this.notifier.notify('default', res['message']);
      });
    }
   
 }

  onItemAdded(event:any,controlName:string){
     var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
     var filter_domain = /^(?:([a-z0-9-]+|\*)\.)?([a-z0-9-]{1,61})\.([a-z0-9]{2,7})$/;
     if (!filter.test(event.value) && !filter_domain.test(event.value)) {
            this.notifier.notify('error','Please provide a valid email address or domain');
            let tag_value =  this.mailConfigForm.get(controlName)?.value;
            tag_value.splice(tag_value.length-1,1);
    }
  
 }

 

}
